import { render, staticRenderFns } from "./MenuItemFileInput.vue?vue&type=template&id=d2e2ece2&"
import script from "./MenuItemFileInput.vue?vue&type=script&lang=js&"
export * from "./MenuItemFileInput.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemFileInput.vue?vue&type=style&index=0&id=d2e2ece2&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports